import { GrayWhite } from '@box/blueprint-web-assets/tokens/tokens';
import BuieIconInfoThin from 'box-ui-elements/es/icons/general/IconInfoThin';
import BlueprintInfoBadge from '@box/blueprint-web-assets/icons/Line/InfoBadge';
import React from 'react';
import { useShouldRenderBlueprint } from '../../../common/useShouldRenderBlueprint';
import VariantComponent from '../../../common/variant-component';
import css from './preview-disabled-header.module.scss';

const NewIcon = () => {
  return (
    <BlueprintInfoBadge
      className={css.infoIcon}
      data-testid="blueprint-info-badge"
      fill={GrayWhite}
      height={20}
      width={20}
    />
  );
};

const InfoIcon = () => {
  // Should be addressed in FORMS-21247
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      NewComponent={NewIcon}
      OldComponent={BuieIconInfoThin}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default InfoIcon;
